var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "flex-center", attrs: { endTime: _vm.endTime } },
    [
      _vm.type == 1
        ? _vm._t("default", function() {
            return [
              _c("span", { staticClass: "box" }, [_vm._v(_vm._s(_vm.day))]),
              _vm._v(" : "),
              _c("span", { staticClass: "box" }, [_vm._v(_vm._s(_vm.hour))]),
              _vm._v(" : "),
              _c("span", { staticClass: "box" }, [_vm._v(_vm._s(_vm.min))]),
              _vm._v(" : "),
              _c("span", { staticClass: "box" }, [_vm._v(_vm._s(_vm.second))])
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type == 2
        ? _vm._t("default", function() {
            return [
              _c("span", { staticClass: "big-box" }, [_vm._v(_vm._s(_vm.day))]),
              _c("span", { staticClass: "test" }, [
                _vm._v(_vm._s(_vm.$t("300212")))
              ]),
              _c("span", { staticClass: "big-box" }, [
                _vm._v(_vm._s(_vm.hour))
              ]),
              _c("span", { staticClass: "test" }, [
                _vm._v(_vm._s(_vm.$t("300213")))
              ]),
              _c("span", { staticClass: "big-box" }, [_vm._v(_vm._s(_vm.min))]),
              _c("span", { staticClass: "test" }, [
                _vm._v(_vm._s(_vm.$t("300214")))
              ]),
              _c("span", { staticClass: "big-box" }, [
                _vm._v(_vm._s(_vm.second))
              ]),
              _c("span", { staticClass: "test" }, [
                _vm._v(_vm._s(_vm.$t("300215")))
              ])
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type == 3
        ? _vm._t("default", function() {
            return [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.day) + "D")
              ]),
              _vm._v(" : "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.hour) + "H")
              ]),
              _vm._v(" : "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.min) + "M")
              ]),
              _vm._v(" : "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.second) + "S")
              ])
            ]
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6debc06e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6debc06e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/christmasCountDown.vue
// module id = YLEp
// module chunks = 0